<template>
  <v-layout
    class="map__container get-height"
    align-center
    justify-center
    row
    fill-height
  >
    <transition name="fade">
      <img
        v-if="map && imageSrc"
        :src="imageSrc"
        :alt="$t(`${namespace}.map.success`)"
        @error="handleError"
      >
      <span v-else class="map__error">
        {{ $t(`${namespace}.map.error`) }} <strong>;)</strong>
      </span>
    </transition>
  </v-layout>
</template>

<script>
export default {
  name: 'Map',
  props: {
    imageSrc: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      namespace: 'Components.GlobalDrawer.reports',
      map: true
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },

    handleError (event) {
      if (event.type === 'error') {
        this.map = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.map__container {
  background-color: $gray-2;
  height: 200px;
  text-align: center;
}

.map__error {
  padding: 0 60px;
}

.map {
  max-width: 100%;
}
</style>
